import { __assign } from "tslib";
import * as React from 'react';
// tslint:disable-next-line:max-line-length
import { createLegacyBaseTableHeadCellDriver } from '../base-table-head-cell/base-table-head-cell.legacy-driver';
import { TableHeadCell } from './table-head-cell';
import { renderAndMountComponent } from '@wix/answers-lib';
export var createLegacyTableHeadCellDriver = function (wrapper) {
    return createLegacyBaseTableHeadCellDriver(wrapper);
};
export var createTableHeadCell = function (props) {
    var element = renderAndMountComponent(React.createElement(TableHeadCell, __assign({}, props)));
    return createLegacyTableHeadCellDriver(element);
};
//# sourceMappingURL=table-head-cell.legacy-driver.js.map